import { getFullUrl } from 'hubspot-url-utils';
import { getPortalId } from '../../../utils/getPortalId';
export const getUserGuideUrl = () => {
  const portalId = getPortalId();
  return `${getFullUrl('app')}/user-guide/${portalId}`;
};